export const utcTimezones: Record<string, string> = {
  "UTC-12": "Etc/GMT+12",
  "UTC-11": "Pacific/Pago_Pago",
  "UTC-10": "Pacific/Honolulu",
  "UTC-9": "America/Anchorage",
  "UTC-8": "America/Los_Angeles",
  "UTC-7": "America/Denver",
  "UTC-6": "America/Chicago",
  "UTC-5": "America/New_York",
  "UTC-4": "America/Halifax",
  "UTC-3": "America/Argentina/Buenos_Aires",
  "UTC-2": "Etc/GMT+2",
  "UTC-1": "Atlantic/Azores",
  "UTC+0": "Etc/UTC",
  UTC: "Etc/UTC",
  "UTC+1": "Europe/Berlin",
  "UTC+2": "Europe/Athens",
  "UTC+3": "Europe/Moscow",
  "UTC+4": "Asia/Dubai",
  "UTC+5": "Asia/Karachi",
  "UTC+6": "Asia/Dhaka",
  "UTC+7": "Asia/Bangkok",
  "UTC+8": "Asia/Shanghai",
  "UTC+9": "Asia/Tokyo",
  "UTC+10": "Australia/Sydney",
  "UTC+11": "Pacific/Noumea",
  "UTC+12": "Pacific/Auckland",
  "UTC+13": "Pacific/Tongatapu",
  "UTC+14": "Pacific/Kiritimati",
};
